import Route from '@ember/routing/route';
import protectedRoute from 'lumen/utils/decorators/protected-route';

@protectedRoute({ features: ['spider.account_analysis'] })
export default class HotelAccountsRoute extends Route {
  model() {
    return this.modelFor('hotel');
  }
}
